import { render, staticRenderFns } from "./NotizPersonen.vue?vue&type=template&id=778dc49a"
import script from "./NotizPersonen.vue?vue&type=script&lang=js"
export * from "./NotizPersonen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports